import axios from 'axios'
import { AXIOS_CONFIG as config, BACKEND_URLS } from '@/config/index'

// 根据环境获取基础 URL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境使用本地代理
    return config.baseURL.dev
  } else {
    // 生产环境：返回空字符串，由请求拦截器根据路径动态设置
    return ''
  }
}

// 请求拦截器函数：根据请求路径动态设置 baseURL（仅生产环境）
const setupBaseURLInterceptor = (axiosConfig) => {
  // 如果是生产环境，根据请求路径动态设置 baseURL
  if (process.env.NODE_ENV !== 'development') {
    let url = axiosConfig.url || ''
    
    // 规范化 URL：确保 URL 以 / 开头（处理 'api/...' 这种情况）
    if (url && !url.startsWith('/')) {
      url = '/' + url
      axiosConfig.url = url
    }
    
    // /jsqm 和 /soil 路径使用主后端服务（9999端口）
    if (url.startsWith('/jsqm') || url.startsWith('/soil')) {
      axiosConfig.baseURL = BACKEND_URLS.main
    }
    // /api 路径使用 API 后端服务（18089端口）
    else if (url.startsWith('/api')) {
      axiosConfig.baseURL = BACKEND_URLS.api
    }
    // /JSQM 路径使用中间件服务
    else if (url.startsWith('/JSQM')) {
      // 如果需要，可以在这里配置中间件地址
      // axiosConfig.baseURL = 'http://47.106.207.240:21047'
      axiosConfig.baseURL = BACKEND_URLS.main // 临时使用主后端，如需修改请取消注释上一行
    }
    // 其他路径，默认使用主后端服务
    else {
      axiosConfig.baseURL = BACKEND_URLS.main
    }
  }
  
  return axiosConfig
}

// 设置全局 axios 默认配置
axios.defaults.withCredentials = true
axios.defaults.timeout = 30000

// 设置全局请求拦截器（适用于所有 axios 请求，包括直接使用 axios.get/post 等）
axios.interceptors.request.use(
  setupBaseURLInterceptor,
  (error) => {
    return Promise.reject(error)
  }
)

//请求响应函数
export function request(requestConfig) {
  const http = axios.create({
    baseURL: getBaseURL(),
    timeout: 30000,
  })

  // 为这个实例也设置相同的拦截器（确保一致性）
  http.interceptors.request.use(
    setupBaseURLInterceptor,
    (error) => {
      return Promise.reject(error)
    }
  )

  return http(requestConfig);
}

// 导出配置好的 axios 实例，供其他地方直接使用
export { axios }






// import axios from 'axios'
// import { AXIOS_CONFIG as config } from '@/config/index'

// const baseURL = process.env.NODE_ENV === 'development' ? config.baseURL.dev : config.baseURL.prod;
// axios.defaults.withCredentials = true;
// //请求响应函数
// export function request(config) {
//   const http = axios.create({
//     baseURL: baseURL,
//     timeout: 30000,
//   })
//   return http(config);
// }